<template>
  <div class="opc-select-cycle">
    <!-- Text View Model -->
    <config-text-row
      v-if="textViewModel"
      :title="$t('billing.plan')"
      :value="billingCycleOptions?.[0]?.options?.[0]?.cycleLabel"
    />

    <!-- Cycle Select -->
    <div v-else class="opc-select-cycle--wrap">
      <span>{{ $t('billing.plan') }}</span>
      <cycle-select
        ref="opcSelectCycle"
        popper-append-to-body
        :model-value="billingCycle"
        @update:model-value="changeBillingCycle"
        :plans="currentGroupPlanList"
        :aria-label="`${planName} Free Trial`"
        :label="`${planName} Free Trial`"
        :post-label="getSavePercentLabel(billingCycle === BILLING_CYCLE.ANNUAL)"
        :action="switchBillingCycle"
        class="opc-capacity-config-row__capacity--select"
        floating-content-class="opc-capacity-config-row__capacity--popper"
      >
        <template #trigger="{ label, value }">
          <span> {{ label }}</span>
          <save-count
            v-if='value === BILLING_CYCLE.ANNUAL'
            class="opc-select-cycle__inner"
            :annualPrice='currentPlanCyclePrice?.annual'
            :monthlyPrice='currentPlanCyclePrice?.monthly'
          />
        </template>
        <zm-select-option-group
          v-for="group in billingCycleOptions"
          :key="group.label"
          :label="group.label"
        >
          <zm-select-option
            v-for="p in group.options"
            :key="p.billing_cycle"
            :data-testid="`checkout-radio-billing-cycle-${p.plan_code}`"
            :disabled="p.disabled"
            :value="p.billing_cycle"
            :label="p.cycleLabel"
            :post-label="getSavePercentLabel(p.billing_cycle === BILLING_CYCLE.ANNUAL)"
          >
            <opc-option-item
              :annual-price="currentPlanCyclePrice?.annual"
              :monthly-price="currentPlanCyclePrice?.monthly"
              :is-show-save-count="p.billing_cycle === BILLING_CYCLE.ANNUAL"
              :label="p.cycleLabel"
              :tooltip-content="p.tooltips"
            />
          </zm-select-option>
        </zm-select-option-group>
      </cycle-select>
    </div>
  </div>
</template>

<script>
import ConfigCycleV2 from '@/components/service/config-billing-cycle/v2/index';

export default {
  name: 'config-cycle-v2-free-trial',
  extends: ConfigCycleV2,
};
</script>
